import React from "react";
import { Modal, Button, Text, Stack } from "@mantine/core";

export default function MembershipRequiredModal({ setView }) {
  return (
    <Modal opened={true} withCloseButton={false} centered>
      <Stack>
        <Text align="center" size="lg">
          To continue, you need to join.
        </Text>
        <Button size="md" fullWidth onClick={() => setView("membership")}>
          Join Now
        </Button>
      </Stack>
    </Modal>
  );
}
